import { Injectable, inject } from '@angular/core';

import { OnFeatureInit } from '@frontend/vanilla/core';

import { BonusBalanceService } from './bonus-balance.service';

@Injectable()
export class BonusBalanceBootstrapService implements OnFeatureInit {
    private bonusBalanceService = inject(BonusBalanceService);

    onFeatureInit() {
        this.bonusBalanceService.refresh();
    }
}
